export default __webpack_public_path__ + "static/media/grafema_pilates_07.b4e3cd90.jpg";